import useSWRImmutable from 'swr/immutable'
import { trackerAPIFetcher, urlCarriers } from '../libraries/tracker.api'
import { ICarrierListSupportedResponse } from '@geartrack/shared-lib/dist/tracker-api/httpResponsesTypes'

/**
 * Fetch the compatibile carriers for a given tracking id
 * @param trackingId
 */
const useCarriersForTrackingId = (trackingId: string): { data: ICarrierListSupportedResponse; error: any } => {
  const { data, error } = useSWRImmutable(urlCarriers(trackingId?.trim()), trackerAPIFetcher)

  return { data, error }
}

export default useCarriersForTrackingId
